import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import globalsService from '../../../services/GlobalsService';
import { t } from '../../../services/i18nService';
import { setPhotoData, clearPhotoData } from '../../../actions/IdVerificationActions';

import styles from './capturedevice.scss';

class CapturedPhoto extends React.PureComponent {
    static propTypes = {
        photo: PropTypes.object,
        photoData: PropTypes.string,
        dispatch: PropTypes.func.isRequired,
    };

    componentDidUpdate(prevProps) {
        const { photo, dispatch } = this.props;
        if (photo !== prevProps.photo) {
            if (photo) {
                const reader = new FileReader();
                reader.onloadend = () => dispatch(setPhotoData(reader.result));
                reader.onerror = dispatch(clearPhotoData);
                reader.readAsDataURL(photo);
            } else {
                dispatch(clearPhotoData());
            }
        }
    }

    render() {
        const { photoData } = this.props;

        let className = styles.capturedPhoto;
        let img = null;

        const hasPhoto = photoData !== null;
        const wrapperClassName = hasPhoto ? null : styles.placeholderWrapper;

        if (hasPhoto) {
            img = (
                <img
                    src={photoData}
                    alt={t('idVerification.captureDevice.capturedPhotoAltText')}
                    className={styles.capturedPhotoImage}
                />
            );
        } else {
            const assetRoot = globalsService.getAssetRoot();
            let webcamGrayPath = 'images/idverification/webcam-gray.svg';

            if (assetRoot) {
                webcamGrayPath = `${assetRoot}/${webcamGrayPath}`;
            }

            className += ` ${styles.placeholder}`;
            img = (
                <img
                    src={webcamGrayPath}
                    alt={t('idVerification.captureDevice.placeholderAltText')}
                    className={styles.placeholderIcon}
                />
            );
        }

        return (
            <div className={className}>
                <div className={wrapperClassName}>
                    {img}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    photoData: state.idverification.photoData,
});

const ConnectedCapturedPhoto = connect(mapStateToProps)(CapturedPhoto);

export default ConnectedCapturedPhoto;
